import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import { type AISmartButtonState, AISmartButtonStore } from '../../ai-smart-button-store';

/**
 * Hook to access nudges from the AISmartButton state.
 */
export const useAINudges: HookStateFunction<ConversationAction[], void> = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.nudges,
});

/**
 * Hook to access button clicked timestamp from the AISmartButton state.
 */
export const useAIButtonClickedTimestamp: HookStateFunction<number | undefined, void> = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.buttonClickedTimestamp,
});
